/* eslint-disable react-hooks/exhaustive-deps */
import { DependencyList, useEffect, useRef } from 'react';

export default function useOnUpdate(
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  fn: Function,
  deps: DependencyList = [],
): void {
  const isInitialMount = useRef(true);
  const prevValue = useRef(deps);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      const cleanUpFn = fn(prevValue.current);
      prevValue.current = deps;
      if (typeof cleanUpFn?.then !== 'function') {
        return cleanUpFn;
      }
    }
  }, deps);
}
